const CREATE_GLOBALLY = 89;
const UPDATE_GLOBALLY = 91;
const DELETE_GLOBALLY = 93;
const UPDATE_OWN_GLOBALLY = 92;
const DELETE_OWN_GLOBALLY = 94;

const ADMINISTER_BRANCH_OFFICES = 118;

const LOADING = 'loading';
const ERROR = 'error';
const SUCCESS = 'success';
const PAUSE = 'pause';
const ABORTED = 'aborted';

export const UPLOADING_FILES = 'EGWWRITINGS_UPLOAD_MANAGER_UPLOADING_FILES';

export const permissionTypes = {
  CREATE_GLOBALLY,
  UPDATE_GLOBALLY,
  DELETE_GLOBALLY,
  UPDATE_OWN_GLOBALLY,
  DELETE_OWN_GLOBALLY,
};

export const allPermissions = {
  ADMINISTER_BRANCH_OFFICES,
};

export const uploadStatus = {
  LOADING,
  ERROR,
  SUCCESS,
  PAUSE,
  ABORTED,
};

export default {
  permissionTypes,
  uploadStatus,
  UPLOADING_FILES,
};



// WEBPACK FOOTER //
// ./src/helpers/constants.js